import React, { useState, useEffect, useRef } from 'react';
import { stockSearchService } from '../config/api';

const StockSearchInput = ({ onSelect, initialValue = '' }) => {
    const [stockOptions, setStockOptions] = useState([]);
    const [stockSearchLoading, setStockSearchLoading] = useState(false);
    const [stockInputValue, setStockInputValue] = useState(initialValue);
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);

    // Handle click outside to close dropdown
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    // Sync initial value if it changes externally
    useEffect(() => {
        if (initialValue) {
            setStockInputValue(initialValue);
        }
    }, [initialValue]);

    const handleStockSearch = async (query) => {
        if (!query || query.length < 2) {
            setStockOptions([]);
            setShowDropdown(false);
            return;
        }

        try {
            setStockSearchLoading(true);
            const response = await stockSearchService.search(query);
            const stocks = response.data || [];
            setStockOptions(stocks.slice(0, 10)); // Limit to 10 results
            setShowDropdown(stocks.length > 0);
        } catch (error) {
            console.error('Error searching stocks:', error);
            setStockOptions([]);
            setShowDropdown(false);
        } finally {
            setStockSearchLoading(false);
        }
    };

    const handleSelect = (stock) => {
        const symbol = typeof stock === 'string' ? stock : stock.tradingSymbol;
        setStockInputValue(symbol);
        setShowDropdown(false);
        if (onSelect) {
            onSelect(stock);
        }
    };

    return (
        <div className="w-full relative" ref={wrapperRef}>
            <label className="label">
                <span className="label-text">Symbol</span>
            </label>
            <div className="relative">
                <input
                    type="text"
                    placeholder="Search Symbol (e.g. RELIANCE)"
                    className="input input-bordered w-full"
                    value={stockInputValue}
                    onChange={(e) => {
                        setStockInputValue(e.target.value);
                        handleStockSearch(e.target.value);
                    }}
                    onFocus={() => stockOptions.length > 0 && setShowDropdown(true)}
                />
                {stockSearchLoading && (
                    <span className="loading loading-spinner loading-sm absolute right-3 top-3"></span>
                )}
            </div>

            {/* Dropdown */}
            {showDropdown && stockOptions.length > 0 && (
                <ul className="menu bg-base-200 rounded-box absolute z-50 w-full mt-1 shadow-lg max-h-60 overflow-auto top-full">
                    {stockOptions.map((option) => (
                        <li key={option.id || option.tradingSymbol}>
                            <button
                                className="flex flex-col items-start p-2"
                                onClick={() => handleSelect(option)}
                            >
                                <span className="font-bold text-base-content">{option.tradingSymbol}</span>
                                <span className="text-xs text-base-content/50">{option.name} • {option.exchange}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default StockSearchInput;
